import UpdateCardRow from './UpdateCardRow'

export default UpdateCardRow
